import { render, staticRenderFns } from "./UserRemoveDialog.vue?vue&type=template&id=45ba4023&scoped=true"
import script from "./UserRemoveDialog.vue?vue&type=script&lang=js"
export * from "./UserRemoveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba4023",
  null
  
)

export default component.exports